/**
 * The "Co-Living-Einheiten & Zimmer" section (Co-Living redesign, Slice 3).
 *
 * WHAT THIS REPLACES. `RoomMap`, as rendered on /admin/rooms. RoomMap itself is
 * untouched and still serves AdminUnitDetailPage — this is a second, local view
 * of the same data shaped for this page, not a rewrite of a shared component.
 *
 * PRESENTATIONAL. AdminRoomsPage stays the owner of the data, the filters and
 * the expand state; this section receives them. It computes nothing about
 * occupancy and fetches nothing.
 *
 * THE TITLE SAYS "EINHEITEN". The hierarchy on this page is unit → room, and
 * the heading has to say so: "Liegenschaften & Zimmer" would name a level the
 * page does not render.
 */
import React from "react";

import CoLivingUnitRow from "./CoLivingUnitRow";
import { formatUnitCount } from "./roomDisplayHelpers";

export default function CoLivingUnitsSection({ units, emptyMessage }) {
  return (
    <section>
      <div className="mb-[10px] flex flex-wrap items-end justify-between gap-x-4 gap-y-1">
        <div className="min-w-0">
          <h2 className="m-0 text-[15px] font-semibold leading-tight text-foreground">
            Co-Living-Einheiten &amp; Zimmer
          </h2>
          <p className="m-0 mt-1 text-[12px] leading-snug text-muted-foreground">
            Alle Co-Living-Einheiten mit Zimmerstatus, Miete und Belegung.
          </p>
        </div>
        <span className="shrink-0 text-[12px] tabular-nums text-muted-foreground">
          {formatUnitCount(units.length)}
        </span>
      </div>

      {units.length === 0 ? (
        <p className="m-0 rounded-[12px] border border-border bg-card px-4 py-8 text-center text-[13px] text-muted-foreground">
          {emptyMessage}
        </p>
      ) : (
        <div className="flex flex-col gap-2.5">
          {units.map((u) => (
            <CoLivingUnitRow key={u.unitId} {...u} />
          ))}
        </div>
      )}
    </section>
  );
}
